import React, { useMemo } from "react"

import Drawer, { DrawerProps } from "@mui/material/Drawer"

import { useAppDrawer } from "@hooks/useAppDrawer"
import useSession from "@hooks/useSession"

import OrgSwitcher from "@components/OrgSwitcher"

import { sidebarSubMenus, featureNavs } from "@constants/features"

import { SidebarMenu } from "../SidebarMenu"
import { prependFavoriteFeatures } from "../SidebarMenu/prependFavoriteFeatures"
import { topNavigationHeight } from "../TopNavigation"

export const appDrawerWidth = 224 // Equal to theme.spacing(28)
export const AppDrawer: React.FC<DrawerProps> = (props) => {
  const { open } = useAppDrawer()
  const { orgMember } = useSession()

  const availableSubMenus = useMemo(() => {
    const favoriteFeatures =
      orgMember?.settings?.starredFeatures?.edges.map((edge) => ({
        name: edge.node.name,
      })) ?? []

    return prependFavoriteFeatures({
      subMenus: sidebarSubMenus,
      favoriteFeatures,
      featureNavs,
    })
  }, [orgMember?.settings?.starredFeatures?.edges])

  return (
    <Drawer
      variant="persistent"
      open={open}
      sx={{ zIndex: 1 }}
      anchor="left"
      transitionDuration={50}
      PaperProps={{
        sx: (theme) => ({
          border: "none",
          boxShadow: "none",
          whiteSpace: "nowrap",
          zIndex: 1,
          width: appDrawerWidth,
          pt: `${topNavigationHeight}px`,
          background: theme.palette.background.default,
          borderRight: `1px solid ${theme.palette.divider}`,
          overflowX: "hidden",
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }),
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <SidebarMenu
        subMenus={availableSubMenus}
        orgSwitcher={<OrgSwitcher />}
        showSupportSection={true}
      />
    </Drawer>
  )
}
